<div class="modal__backdrop"></div>
<div class="modal__dialog">
  <ng-template #modalContainer></ng-template>
</div>
